module.exports = __webpack_public_path__ + "img/fiddlers.ea6a502d.jpg";